<template>
<!--    <div class="login-layout">-->
<!--        <headerCustom layout="login" />-->
<!--        <main class="login">-->
<!--            <router-view />-->
<!--        </main>-->
<!--        <footerMain/>-->
<!--    </div>-->
  <div class="onboarding-layout">
    <main class="onboarding-main">
      <router-view />
    </main>
  </div>
</template>

<script>
import footerMain from '@/components/app/footerMain';
import headerCustom from '@/components/app/headerCustom';

export default {
  //name: 'login-layout',
  name: 'OnboardingLayout',
  components:{
    headerCustom, footerMain
  }
};
</script>

<style lang="scss">
//@import '~bootstrap/dist/css/bootstrap.min.css';
//@import '../assets/sass/app/app.scss';
//@import  '../shared/styles/style.css';
//@import  '../shared/styles/base/_main.scss';

//.onboarding-layout {
//  min-height: 100vh;
//  background-color: #f4f6f9;
//  display: flex;
//  flex-direction: column;
//}
//.onboarding-main {
//  flex: 1;
//  padding: 20px 0;
//}
</style>
